import SubTabs from "./SubTabs";
import usePyqRedux from "../hooks/usePyqRedux";
import { useGetTabsList } from "../hooks/useGetTabsList";
import YearsList from "./YearsList";
import "./MainTabs.css";

const MainTabs = () => {
  const { data } = useGetTabsList();
  const {
    pyqMainCurrentTab,
    pyqSubCurrentTab,
    setPyqMainCurrentTab,
    setPyqSubCurrentTab,
  } = usePyqRedux();

  const handleOnClick = (tab) => {
    setPyqMainCurrentTab(tab);
    setPyqSubCurrentTab(tab?.pyqSubList[0]);
  };

  return (
    <div>
      <div className="main-tabs-container">
        <ul className="main-tabs">
          {data?.data?.map((tab, index) => (
            <li
              key={index}
              className={`main-tab ${
                tab.name == pyqMainCurrentTab.name ? "pyq-main-tab-active" : ""
              }`}
              onClick={() => handleOnClick(tab)}
            >
              {tab.name}
            </li>
          ))}
        </ul>
      </div>
      <div className="sub-tabs-and-yearlist">
        <SubTabs tabs={data} />
        {pyqSubCurrentTab?.index == 1 && <YearsList />}
      </div>
    </div>
  );
};

export default MainTabs;
